import { inputCategories } from '@/common/components/MatchTypeEditor/constants'
import { getInputCategory } from '@/common/components/MatchTypeEditor/helpers'

export const getValueForCategory = criterion => {
  const category = getInputCategory(criterion.match_type, criterion.field)

  if (category === inputCategories.multiValue) return criterion.match_values
  if (category === inputCategories.region) return criterion.match_values
  if (category === inputCategories.dateRange) {
    return { startDate: criterion.date_range_start, endDate: criterion.date_range_end }
  }
  if (category === inputCategories.daysElapsed) return criterion.days_value
  if (category === inputCategories.range) {
    return { min_value: criterion.min_value, max_value: criterion.max_value }
  }

  return criterion.match_value
}
